module.exports = __webpack_public_path__ + "img/granstra_gray.d95f56e3.svg";